

import { HttpClient, HttpHeaders, HttpEventType, HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-uploader',
  templateUrl: './uploader.component.html',
  styleUrls: ['./uploader.component.css']
})
export class UploaderComponent implements OnInit {
  progress: number;
  message: string;
  @Output() public onUploadFinished = new EventEmitter();

  constructor(private http: HttpClient) {
    this.progress = 0;
    this.message = "";
  }

  ngOnInit() {
  }

  uploadFile = (files: any) => {
    if (files.length === 0) {
      return;
    }
    
    let headers = new HttpHeaders()
    var token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImN0eSI6IkpXVCJ9.eyJzdWIiOiJ2aXNod2FqZWV0LmJoYXJ0aUBpbmZvdmlzaW9uLmNvbSIsImp0aSI6ImUyNzdmODA5LWQ5MjItNDYzMy04NjcwLTg5NWViMmM3ZDdlNiIsImZpcnN0bmFtZSI6InZpc2h3YWplZXQiLCJsYXN0bmFtZSI6ImJoYXJ0aSIsInVzZXJpZCI6ImNiOGM5MTgwLTZkZWMtNDlkOS04N2FlLTdjNTVjMDgyNGZmNyIsImN1c3RvbWVyaWQiOiJjYjhjOTE4MC02ZGVjLTQ5ZDktODdhZS03YzU1YzA4MjRmZjciLCJ1c2VybmFtZSI6InZpc2h3YWplZXQuYmhhcnRpQGluZm92aXNpb24uY29tIiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvZW1haWxhZGRyZXNzIjoidmlzaHdhamVldC5iaGFydGlAaW5mb3Zpc2lvbi5jb20iLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL3JvbGUiOiJ1c2VyIiwiaXNhY3RpdmUiOiJUcnVlIiwiZXhwIjoxNjg2NjQxNzQ3LCJpc3MiOiJodHRwczovL2xvY2FsaG9zdDo1MDAxIiwiYXVkIjoiaHR0cHM6Ly9sb2NhbGhvc3Q6NTAwMSJ9.8fEn_TuDhyctrDndoM9p87D6dWqlW6UZxnaSdPkc8Qc";
    headers = headers.append('Authorization', 'Bearer ' + token)
    // headers= headers.append('Authorization', 'Bearer ' + token);

    // debugger;
    let fileToUpload = <File>files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload);

    this.http.post('https://ng.afstest.com/apiCustomerPortal/api/Users/upload', formData, {  headers, reportProgress: true, observe: 'events'})
     // this.http.post('https://localhost:5001/api/upload', formData, {  headers, reportProgress: true, observe: 'events'})
      .subscribe({
        next: (event) => {
          if (event.type === HttpEventType.UploadProgress && event.total)
            this.progress = Math.round(100 * event.loaded / event.total);
          else if (event.type === HttpEventType.Response) {
            this.message = 'Upload success.';
            this.onUploadFinished.emit(event.body);
          }
        },
        error: (err: HttpErrorResponse) => console.log(err)
      });
  }
}